import { State } from 'app/redux';

export const getSettingsShipping = (state: State) => state.settings.shipping;
